import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from './services';
import { distinctUntilChanged, take } from 'rxjs/operators';

@Component({
  selector: 'app-route-refresh',
  template: '',
  styles: []
})

export class RouteRefreshComponent implements OnInit, OnDestroy {

  private subscription;

  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.subscription = this.userService.isAuthenticated
      .pipe(distinctUntilChanged())
      .subscribe(
        (isAuthenticated) => {
          if (isAuthenticated) {
            const currentUser = this.userService.getCurrentUser();
            const currentRole = currentUser && currentUser.role;
            if (currentRole === 'ROLE_API_ADMIN') {
              this.router.navigateByUrl('/admin/managers');
            } else
            if (this.userService.getRole() === 1) {
              this.router.navigateByUrl(this.userService.getMyPatientCardUrl());
            } else
            if (this.userService.getRole() === 2) {
              // ratownik telecentrum startuje od listy alarmów (zdarzeń), pozostali opiekunowie od podopiecznych
              this.userService.isTelecentrumMode().pipe(take(1)).subscribe(
                mode => this.router.navigateByUrl(mode ? '/my-dashboard' : '/users'),
                () => this.router.navigateByUrl('/users')
              );
            } else if (this.userService.getRole() === 3) {
              this.router.navigateByUrl('/manager/dashboard');
            }
          } else {
            this.router.navigateByUrl('auth/login');
          }
        }
      );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
